module.exports = __webpack_public_path__ + "media/images/guide/image7-fde1bed941992dd0438ae835af413c61.png";